var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"video",staticClass:"video-js vjs-16-9 vjs-theme-fantasy vjs-big-play-centered",attrs:{"preload":"metadata","controls":"","playsinline":"","webkit-playsinline":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }